import { render, staticRenderFns } from "./blogs.vue?vue&type=template&id=7277cce5&scoped=true"
import script from "./blogs.vue?vue&type=script&lang=js"
export * from "./blogs.vue?vue&type=script&lang=js"
import style0 from "./blogs.vue?vue&type=style&index=0&id=7277cce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7277cce5",
  null
  
)

export default component.exports